import {OpeningDayExceptionDto} from '@lib/infrastructure';
import {OpeningDayException} from '../../entities';

export const toOpeningDaysExceptions = (exceptions: OpeningDayExceptionDto[]): OpeningDayException[] =>
  exceptions.map(toOpeningDayException);

export const toOpeningDayException = (exception: OpeningDayExceptionDto): OpeningDayException => ({...exception});
